export type SystemRole = "patient" | "clinician" | "admin" | "superadmin";

export type ProfileRole = "patient" | "student" | "technician" | "doctor" | "specialist";

export type BusinessRole = "doctor" | "technical" | "staff" | "owner";

export type RoleKind = SystemRole | ProfileRole | BusinessRole;

export interface RoleContext {
  systemRole: SystemRole;
  profileRole: ProfileRole | null;
  businessRole?: BusinessRole;
}

// Fragmente të rrugëve klinike — RoleGuard i përdor për Clinical Isolation
// Kushtetuta §III: admin/superadmin FORBIDDEN nga këto seksione
export const CLINICAL_ROUTE_FRAGMENTS = [
  "patient/history",
  "professional/reports",
  "patient/monitoring",
  "doctor/monitoring",
  "imaging",
  "laboratory",
  "laboratory/results",
  "family/history",   // §VI: historiku familjar = të dhëna klinike, i ndaluar për admin
] as const;
export type ClinicalRouteFragment = typeof CLINICAL_ROUTE_FRAGMENTS[number];
